import createIcon from '../../createIcon';

/**
 * @component @name LocalPharmacy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNkgxOC4zNkwxOS41IDIuODZMMTcuMTUgMkwxNS42OSA2SDNWOEw1IDE0TDMgMjBWMjJIMjFWMjBMMTkgMTRMMjEgOFY2Wk0xNiAxNUgxM1YxOEgxMVYxNUg4VjEzSDExVjEwSDEzVjEzSDE2VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalPharmacy = createIcon('LocalPharmacy', [
  [
    'path',
    {
      d: 'M21 6H18.36L19.5 2.86L17.15 2L15.69 6H3V8L5 14L3 20V22H21V20L19 14L21 8V6ZM16 15H13V18H11V15H8V13H11V10H13V13H16V15Z',
      key: 'hlrj7o',
    },
  ],
]);

export default LocalPharmacy;
